import React, { useCallback, useEffect } from 'react';
import { Form, Input, Row, Col, notification } from 'antd';
import { FormInstance } from 'antd/lib/form';
import {
  createThirdPartyAddress,
  TpAddressResponse2,
  updateThirdPartyAddres,
} from 'services/thirdParty';
import ButtonLink from 'components/theme_components/ButtonLink';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { useForm } from 'antd/lib/form/Form';
import Address from 'components/theme_components/ThirdParty/address';
import AddressSFS from 'components/theme_components/ThirdParty/address/AddresseSFS';

export type AddresseModalProps = {
  address?: TpAddressResponse2;
  setVisible: (visible: boolean) => void;
  tpid: number;
  refetch?: () => void;
   disableType?: boolean;

};

const AddresseModal = ({
  setVisible,
  address,
  tpid,
    disableType,
  refetch
}: AddresseModalProps) => {
  console.log({ address }, Number(tpid));

  const [form] = useForm();
  useEffect(() => {
    if (address) {
      form.setFieldsValue(address);
      console.log("initial  address =>", address)
    } else {
      form.setFieldsValue(initialValue);
      console.log("initial =>", initialValue)
    }
  }, [form, address]);
  const onSave = useCallback(

    (record: any) => {
      !address
        ? createThirdPartyAddress({
          tpAddressRequest: { ...record, tpid },
          tpid: Number(tpid),
        }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: response.message,
            });
            setVisible(false)
            refetch && refetch();
          }
        })
        : updateThirdPartyAddres({
          tpAddressRequest: record,
          tpadrid: address?.tpadrid,
          tpid: address?.tpid,
        }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: response.message,
            });
            setVisible(false)
            refetch && refetch();
          }
        });
    },
    [tpid]
  );
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => {
        const record = {
          ...values,
          tpadrid: form.getFieldValue('listAdresses')?.tpadrid,
        };
        onSave(record);
        console.log("hedhoom el values =>",values);
      }}
    >
      <div style={{ padding: 10 }}  >
        <Row gutter={[3, 3]} className='no-border-radius'>
          <FormInput name="adrtype" col md={24} className='btn-modal'>
            <ParListSelect parcode="ADRTYPE" className="ut-input-modal" disabled={disableType} />
          </FormInput>

          <FormInput
            name="tpmainadrstreet1"
            rules={[{ required: true,
              message:"please enter street 1 "
             }]}
            col md={24}
          >
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput
            name="tpmainadrstreet2"
            col md={24}       
          >
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput
            name="tpmainadrstreet3"          
            col md={24}
          >
            <Input className="ut-input-modal" />
          </FormInput>


          {/* <FormInput col md={24} name="tpmainadrzipcode" rules={[{ required: true }]}
          >
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput col md={24} name="tpmainadrcity" rules={[{ required: true }]}
          >
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput col md={24} name="tpmainadrcountry" rules={[{ required: true }]}
          >
            <Input className="ut-input-modal" />
          </FormInput> */}


          <AddressSFS
            form={form}
            codePostalField="tpmainadrzipcode"
            paysField="tpmainadrcountry"
            regionField="tpmainadrregion"
            villeField="tpmainadrcity"
            comcodecodePostalField="tpmainadrzipcodeTP"
            comcodepaysField="tpmainadrcountryTP"
            comcoderegionField="tpmainadrregionTP"
            comcodevilleField="tpmainadrcityTP"
            colU={24}
            hideRegionGlobal
            hideRegion
            Colw={(localStorage.getItem('lancode') === 'FR') ? { span: 10 } : { span: 4 }}
            spanCountry={24}
            spanZip={24}
            spanCity={24}
            cityRequired
            zipcodeRequired
            countryRequired
            className="ut-input-modal no-border-radius"
          />

        </Row>
        <Row justify={'end'} style={{ marginTop: 13 }}>
          <ButtonLink comcode='Annuler' className='ut-reset-btn'
            onClick={() => setVisible(false)} />
          <ButtonLink
            type="primary"
            comcode='Valider'
            htmlType="submit"
            className='ut-submit-btn'
            style={{ marginLeft: 10 }}
          />
        </Row>
      </div>

    </Form>
  );
};
const initialValue = {
  adrenddate: '',
  adrstartdate: '',
  adrstatus: '',
  adrstatusdate: '',
  adrtype: '',
  tpadrid: 0,
  tpid: 0,
  tpmainadrcity: '',
  tpmainadrcountry: '',
  tpmainadrregion: '',
  tpmainadrregionglobale: '',
  tpmainadrstreet1: '',
  tpmainadrstreet2: '',
  tpmainadrzipcode: '',
};
export default AddresseModal;
